export default function(ctx) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p +=
((__t = (ctx.element)) == null ? '' : __t) +
'\n<div\n  class="signature-pad-body"\n  tabindex="' +
((__t = (ctx.component.tabindex || 0)) == null ? '' : __t) +
'"\n  ref="padBody"\n>\n  <button\n    type="button"\n    class="btn btn-sm btn-light signature-pad-refresh utrecht-button utrecht-button--html-button utrecht-button--subtle"\n    ref="refresh"\n  >\n    <i class="' +
((__t = (ctx.iconClass('refresh'))) == null ? '' : __t) +
'">\n      <!-- For accessibility a Button element must contain text content -->\n      <span class="sr-only">' +
((__t = (ctx.t('Refresh'))) == null ? '' : __t) +
'</span>\n    </i>\n  </button>\n  <canvas class="signature-pad-canvas" height="' +
((__t = (ctx.component.height)) == null ? '' : __t) +
'" ref="canvas"></canvas>\n  ';
 if (ctx.required) { ;
__p += '\n  <span class="form-control-feedback field-required-inline text-danger">\n    <i class="' +
((__t = (ctx.iconClass('asterisk'))) == null ? '' : __t) +
'"></i>\n  </span>\n  ';
 } ;
__p += '\n  <img ref="signatureImage" class="signature-pad-body__image" />\n</div>\n';
 if (ctx.component.footer) { ;
__p += '\n<div class="signature-pad-footer">\n  ' +
((__t = (ctx.t(ctx.component.footer, {_userInput: true}))) == null ? '' : __t) +
'\n</div>\n';
 } ;
__p += '\n';
return __p
}